import { translate, TranslationEntity } from '@repo/utils';
import { type NodeProps } from '@xyflow/react';
import NodeMenu from 'automations/components/NodeMenu';
import { type UpdateLeadNodeType } from 'automations/types/nodeSchemas/actionNodes';

import AddLeadFields from './AddLeadFields';

export default function UpdateLeadActionNodeContent({
  node,
}: {
  node: NodeProps<UpdateLeadNodeType>;
}) {
  return (
    <NodeMenu
      node={node}
      drawerProps={{
        title: translate(
          `Action - Update #{${TranslationEntity.lead}}`,
          [{ capitalize: true }],
        ),
      }}
      extraLarge={false}
    >
      <AddLeadFields node={node} />
    </NodeMenu>
  );
}
